import constants from "../constants";
import { getDataFromStorage } from "../util";
import logo from "../assets/images/logo.png";
import { useLocation } from "react-router-dom";
import AlertContext from "../context/AlertContext";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import Loading from "./Notification-Loading/Loading/Loading";
import useCommonFunctionHooks from "../Hooks/useCommonFunctionHooks";
import React, { useContext, useEffect, useRef, useState, useMemo, useCallback } from "react";
import Tooltip from "./CommonComponents/Tooltip";
import useS3FileManagement from "../Hooks/useS3FileManagement";
import InputDropdown from "./CommonComponents/InputDropdown";
import Button from "./Button";
import { DropdownMenu } from "./CommonComponents/InputDropdown";
import Toast from "./CommonComponents/Toast";
import jwt_decode from "jwt-decode";
import useAuth from "../Hooks/useAuth";

const roleRouteMap = {
  [constants.Roles.parent]: {
    route: "/main/landing",
    isAdmin: false,
  },
  [constants.Roles.learner]: {
    route: "/main/landing",
    isAdmin: false,
  },
};

export default function Company() {
  const Alert = useContext(AlertContext);

  const { navigate } = useAuth();

  const { getPreSignedUrl } = useS3FileManagement();
  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  let location = useLocation();

  const from = useRef(location?.state?.from?.pathname || "/");
  const menuButtonRefs = useRef({});
  const [companyDetails, setCompanyDetails] = useState([]);
  const [accountTypeFilter, setAccountTypeFilter] = useState("");
  const [activeCompanyMenuId, setActiveCompanyMenuId] = useState(null);
  const [isManagement, setIsManagement] = useState(false);


  const tabs = useMemo(
    () => [
      {
        id: 1,
        label: "Active",
        archived: false,
      },
      {
        id: 2,
        label: `Archived (${Alert.archivedCompanyCount || 0})`,
        archived: true,
      },
    ],
    [Alert.archivedCompanyCount]
  );

  const getMenuButtonRef = (companyId) => ({
    current: menuButtonRefs.current[companyId],
  });
  const showToast = (type, message) => setToast({ open: true, type, message });
  const [toast, setToast] = useState({ open: false, type: "success", message: "" });
  const closeToast = () => setToast((prev) => ({ ...prev, open: false }));
  const fetchCompanyList = async (showArchivedParam = null) => {
    const showArchived =
      showArchivedParam !== null
        ? Boolean(showArchivedParam)
        : Boolean(Alert.showArchivedCompanies);
    const apiUrl = `/node/learner/accounts?archived=${showArchived}`;

    Alert.setIsLoaded(true);
    try {
      const res = await axios.get(
        apiUrl,
        useCommonFunctionHks.getHeaderDetailsForAxios(),
      );

      if (res.data?.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        Alert.setShowNotify({
          show: true,
          msg:
            res.data?.msg ||
            "An unexpected error occurred. Please try again.",
          title: "Error",
        });
        return;
      }
      Alert.setShowSupAdminControls(res.data.showControls ?? false)
      setIsManagement(res.data.isManagement ?? false)
      Alert.setIsAdmin(res.data.isManagement ?? false);
      if (!res.data.data || res.data.data.length === 0) {
        Alert.setShowNotify({
          show: true,
          msg: "You are not associated with any university. Please contact gradious team.",
          title: "No University Found",
        });
        setCompanyDetails([]);
        return;
      }


      const s3Companies = res.data.data.filter(
        (company) => company.id !== 1 && (company.logo || company.favicon),
      );
      const keys = [
        ...new Set(
          s3Companies.flatMap((company) =>
            [company.logo, company.favicon].filter(Boolean),
          ),
        ),
      ];

      let signedUrls = [];
      if (keys.length > 0) {
        const resUrls = await getPreSignedUrl(keys, undefined, "", "GET");
        signedUrls = resUrls?.url || [];
      }

      const urlByKey = new Map();
      keys.forEach((key, idx) => {
        if (signedUrls[idx]) urlByKey.set(key, signedUrls[idx]);
      });

      const companyData = res.data.data.map((company) => {
        const logoUrl =
          company.id === 1 ? logo : urlByKey.get(company.logo) || null;
        const faviconUrl =
          company.id === 1
            ? company.favicon
            : urlByKey.get(company.favicon) || null;

        return {
          ...company,
          name: company.name,
          company_id: company.id,
          archived: Boolean(company.softdel),
          favicon: faviconUrl,
          logo: logoUrl,
        };
      });
      console.log("Archived count from API response:", res.data.data.archived_count);
      console.log("Company data after processing:", companyData);
      Alert.setArchivedCompanyCount(
        res.data.data[0].archived_count || 0
      );
      Alert.setCompanyInfo(companyData);
      // if (
      //   companyData.length === 1 &&
      //   (getDataFromStorage("role") === constants.Roles.learner ||
      //     getDataFromStorage("role") === constants.Roles.parent)
      // ) {
      //   Alert.setUserBatch([]);
      //   localStorage.setItem("logo", companyData[0].logo);
      //   localStorage.setItem("favicon", companyData[0].favicon);
      //   localStorage.setItem("companyId", companyData[0].company_id);
      //   from.current = "/main/landing";
      //   const encodedData = btoa(JSON.stringify(companyData[0]));
      //   localStorage.setItem("account_response", encodedData);
      //   Alert.navigate("/main/landing", { replace: true });
      // }

      if (
        companyData.length === 1
        //  &&
        // [...MANAGEMENTROLES, Roles.evaluator, Roles.tutor].includes(
        //   getDataFromStorage("role"),
        // )
      ) {
        getCompanyDetails(companyData[0], undefined, res.data.isManagement ?? false);
      }

      setCompanyDetails(companyData);
    } catch (error) {
      useCommonFunctionHks.getCatchBlockDetails(error);
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  useEffect(() => {
    fetchCompanyList();
  }, [Alert.fetchCompanyData, Alert.showArchivedCompanies]);

  // Clear search when leaving the company page
  useEffect(() => {
    return () => {
      if (Alert.setCompanySearch) Alert.setCompanySearch("");
      if (Alert.setShowArchivedCompanies) Alert.setShowArchivedCompanies(false);
    };
  }, []);

  useEffect(() => {
    const closeMenu = () => setActiveCompanyMenuId(null);

    document.addEventListener("click", closeMenu);
    return () => document.removeEventListener("click", closeMenu);
  }, []);

  const navigateByRole = useCallback(
    (role, registered) => {
      const config = roleRouteMap[role];
      console.log("config:", config, "role:", role, registered);

      if (!config) {
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: "You are not authorized to access this platform.",
        });
        navigate("/");
        return;
      }

      if (role === constants.Roles.learner && registered == 0) {
        navigate("/registration", { replace: true });
      } else {
        navigate(config.route, { replace: true });
      }
    },
    [navigate, Alert.setShowNotify],
  );

  const getCompanyDetails = (data, redirectpath = "/batches", isAdmin) => {
    console.log("data........................", data);

    if (!isAdmin) {
      redirectpath = "/main/landing"
    }
    // else {
    Alert.setIsLoaded(true);
    const learnerId = getDataFromStorage("learnerid");

    axios
      .get(
        `/node/admin/${learnerId}/account/${data.company_id}`,
        {
          headers: {
            "Content-Type": "application/json",
          }
        },
      )
      .then((res) => {
        const { accessToken, picture, } = res.data;

        if (!accessToken) {
          throw new Error(res.data.msg);
        }

        localStorage.setItem("tokenKey", res.data.accessToken);
        const decoded = jwt_decode(accessToken);
        // localStorage.setItem("refreshToken", res.data.refreshToken);
        const isCreator = decoded.role === constants.Roles.creator
        if (isCreator) redirectpath = "/library/1/questionlist"
        localStorage.setItem("picture", picture);
        Alert.setAuth({ token: accessToken });
        from.current = redirectpath;
        const encodedData = btoa(JSON.stringify(data));
        localStorage.setItem("account_response", encodedData);
        Alert.setUserBatch([]);
        localStorage.setItem("logo", data.logo);
        localStorage.setItem("favicon", data.favicon);
        localStorage.setItem("companyId", data.company_id);
        localStorage.setItem("university_type", data.type);

        console.log("decoded:",decoded);
        
        if (decoded.role === "learner" || decoded.role === "parent") {
          navigateByRole(decoded.role, decoded.registered);
          Alert.setRegistered(decoded.registered); 
          return;
        }
        Alert.navigate(redirectpath, { replace: true });
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      })
      .finally(() => {
        Alert.setIsLoaded(false);
      });
    // }
  };

  const handleCompanyMenuClick = (event, companyId) => {
    event.stopPropagation();
    setActiveCompanyMenuId((activeId) =>
      activeId === companyId ? null : companyId,
    );
  };

  const handleArchiveCompany = async (event, company) => {
    event.stopPropagation();

    try {
      const isArchived =
        company.softdel === 1 || company.softdel === "1";

      await axios.patch(
        `/node/admin/company/${company.company_id}`,
        {
          softdel: isArchived ? 0 : 1,
        },
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );



      await fetchCompanyList();
      showToast("success", `Company ${isArchived ? "unarchived" : "archived"} .fully.`
      );
      setActiveCompanyMenuId(null);
    } catch (err) {
      console.error(err);
      useCommonFunctionHks.getCatchBlockDetails(err);
    }
  };
  const handleArchivedClick = async (showArchived) => {
    try {
      if (showArchived) {
        const res = await axios.get(
          "/node/learner/accounts?archived=true",
          useCommonFunctionHks.getHeaderDetailsForAxios()
        );

        Alert.setArchivedCompanyCount(
          res.data.data?.[0]?.archived_count || 0
        );
      }

      Alert.setShowArchivedCompanies(showArchived);
    } catch (error) {
      console.error("Error fetching archived companies:", error);
    }
  };

  const handleEditCompany = (event, company, isAdmin) => {
    event.stopPropagation();
    setActiveCompanyMenuId(null);

    // Alert.setShowNotify({
    //   show: true,
    //   title: "Edit Account",
    //   msg: "Edit account flow is not connected yet.",
    // });
    getCompanyDetails(company, "/universitysettings", isAdmin);

  };

  if (Alert.isLoaded) return <Loading />;

  // Filter companies based on the search term from AlertContext
  const searchTerm = Alert.companySearch?.toLowerCase().trim() || "";
  const canManageCompanies =
    Alert.showSupAdminControls;
  const filteredCompanies = companyDetails.filter((company) => {
    const matchesSearch = searchTerm
      ? company.name?.toLowerCase().includes(searchTerm)
      : true;
    const matchesAccountType = accountTypeFilter
      ? Number(company.type) === Number(accountTypeFilter)
      : true;
    // const matchesArchiveView =
    //   Boolean(company.archived) === Boolean(Alert.showArchivedCompanies);

    return matchesSearch && matchesAccountType;
  });


  return (
    companyDetails.length > 1 && (
      <div className="companyWrapper">
        {isManagement && (
          <>
            {/* Header Row */}
            <div className="companyHeaderRow">
              <div className="companyPageTitleRow">
                {/* <h1 className="companyPageTitle">Manage Your Account</h1> */}
                <InputDropdown
                  placeholder="Select account type"
                  value={accountTypeFilter}
                  onChange={(val) => setAccountTypeFilter(val)}
                  options={[
                    { label: "All", value: "" },
                    { label: "University", value: "1" },
                    { label: "Corporate", value: "2" },
                  ]}
                  className="companyTypeFilter"
                />
              </div>
              {canManageCompanies && (<div className="companyTabs">
                {tabs.map((tab) => (
                  <Button
                    key={tab.id}
                    size="sm"
                    disable={false}
                    onClick={() => handleArchivedClick(tab.archived)}
                    className={`companyTab ${Alert.showArchivedCompanies === tab.archived ? "active" : ""
                      }`}
                    hierarchy={{
                      type: "tertiaryGrey",
                      buttonText: tab.label,
                    }}
                  />
                ))}
              </div>)}
            </div>
            <Toast
              open={toast.open}
              type={toast.type}
              message={toast.message}
              onClose={closeToast}
              autoHideDuration={4000}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            />
          </>
        )}
        {/* Cards Grid */}
        {
          <div className={`companyMainContainer${!Alert.isAdmin ? " companyMainContainerLearner" : ""}`}>
            {filteredCompanies.length > 0 ? (
              filteredCompanies.map((company) => (
                <div
                  className={`companyCard${company.softdel ? " archived" : ""}`}
                  key={company.company_id}
                  onClick={(event) => {
                    // Prevent navigation when clicking on the portalled dropdown menu
                    const dropdownId = `company-menu-${company.company_id}`;
                    if (
                      event?.target?.closest &&
                      event.target.closest(`[data-dropdown-id="${dropdownId}"]`)
                    ) {
                      return;
                    }
                    getCompanyDetails(company, undefined, Alert.isAdmin);
                  }}
                >
                  <div className="companyLogo">
                    <img
                      src={company.logo}
                      alt={company.name}
                      className="companyImg"
                    />
                  </div>

                  <div className="companyCardFooter">
                    <div className="companyCardText">
                      <Tooltip title={company.name} placement="top" maxChars={16}>
                        <div className="companyName">{company.name}</div>
                      </Tooltip>

                    </div>
                    {canManageCompanies && (
                      <div
                        ref={(el) => {
                          menuButtonRefs.current[company.company_id] = el;
                        }}
                      >
                        <Button
                          size="sm"
                          disable={false}
                          className="companyMoreIcon"
                          onClick={(event) =>
                            handleCompanyMenuClick(event, company.company_id)
                          }
                          icon={{
                            type: "leading",
                            nospace: true,
                            icon: (
                              <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.9987 8.66663C8.36689 8.66663 8.66536 8.36815 8.66536 7.99996C8.66536 7.63177 8.36689 7.33329 7.9987 7.33329C7.63051 7.33329 7.33203 7.63177 7.33203 7.99996C7.33203 8.36815 7.63051 8.66663 7.9987 8.66663Z"
                                  stroke="#344054"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M7.9987 3.99996C8.36689 3.99996 8.66536 3.70148 8.66536 3.33329C8.66536 2.9651 8.36689 2.66663 7.9987 2.66663C7.63051 2.66663 7.33203 2.9651 7.33203 3.33329C7.33203 3.70148 7.63051 3.99996 7.9987 3.99996Z"
                                  stroke="#344054"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                                <path
                                  d="M7.9987 13.3333C8.36689 13.3333 8.66536 13.0348 8.66536 12.6666C8.66536 12.2984 8.36689 12 7.9987 12C7.63051 12 7.33203 12.2984 7.33203 12.6666C7.33203 13.0348 7.63051 13.3333 7.9987 13.3333Z"
                                  stroke="#344054"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            ),
                          }}
                          hierarchy={{
                            type: "tertiaryGrey",
                            buttonText: "",
                          }}
                        />
                      </div>
                    )}
                    {canManageCompanies &&
                      activeCompanyMenuId === company.company_id && (
                        <DropdownMenu
                          style={{
                            width: "150px",
                          }}
                          placement="top-end"
                          open={true}
                          anchorRef={getMenuButtonRef(company.company_id)}
                          dropdownId={`company-menu-${company.company_id}`}

                          options={[
                            {
                              label: (
                                <div className="dropdownOption">
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7 10.5L9.33333 8.16667L8.51667 7.35L7.58333 8.28333V5.83333H6.41667V8.28333L5.48333 7.35L4.66667 8.16667L7 10.5ZM2.91667 4.66667V11.0833H11.0833V4.66667H2.91667ZM2.91667 12.25C2.59583 12.25 2.31875 12.1382 2.08542 11.9146C1.86181 11.6813 1.75 11.4042 1.75 11.0833V3.80625C1.75 3.67014 1.76944 3.53889 1.80833 3.4125C1.85694 3.28611 1.925 3.16944 2.0125 3.0625L2.74167 2.17292C2.84861 2.03681 2.97986 1.93472 3.13542 1.86667C3.30069 1.78889 3.47083 1.75 3.64583 1.75H10.3542C10.5292 1.75 10.6944 1.78889 10.85 1.86667C11.0153 1.93472 11.1514 2.03681 11.2583 2.17292L11.9875 3.0625C12.075 3.16944 12.1382 3.28611 12.1771 3.4125C12.2257 3.53889 12.25 3.67014 12.25 3.80625V11.0833C12.25 11.4042 12.1333 11.6813 11.9 11.9146C11.6764 12.1382 11.4042 12.25 11.0833 12.25H2.91667ZM3.15 3.5H10.85L10.3542 2.91667H3.64583L3.15 3.5Z" fill="#344054" />
                                  </svg>
                                  {/* Archive SVG */}
                                  <span>{company.softdel ? "Unarchive" : "Archive"}</span>
                                </div>
                              ),
                              value: "archive",
                            },
                            {
                              label: (
                                <div className="dropdownOption">
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_10095_1379)">
                                      <path d="M10.4987 5.83331L8.16538 3.49997M1.45703 12.5416L3.43125 12.3223C3.67245 12.2955 3.79305 12.2821 3.90577 12.2456C4.00578 12.2132 4.10096 12.1675 4.18872 12.1096C4.28763 12.0444 4.37343 11.9586 4.54504 11.787L12.2487 4.08331C12.893 3.43898 12.893 2.39431 12.2487 1.74997C11.6044 1.10564 10.5597 1.10564 9.91538 1.74997L2.21171 9.45363C2.0401 9.62524 1.9543 9.71104 1.88907 9.80996C1.8312 9.89771 1.78546 9.99289 1.75308 10.0929C1.71659 10.2056 1.70319 10.3262 1.67639 10.5674L1.45703 12.5416Z" stroke="#344054" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_10095_1379">
                                        <rect width="14" height="14" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <span>Edit Account</span>
                                </div>
                              ),
                              value: "edit",
                            },
                          ]}
                          onSelectOption={(value) => {
                            // Note: DropdownMenu options call onSelectOption without the click event.
                            // Navigation is already prevented at the card level for portalled menus.
                            if (value === "archive") {
                              handleArchiveCompany(
                                { stopPropagation: () => { } },
                                company
                              );
                            }

                            if (value === "edit") {
                              handleEditCompany({ stopPropagation: () => { } }, company, Alert.isAdmin);
                            }

                            setActiveCompanyMenuId(null);
                          }}
                          value={null}
                          multiple={false}
                          onClose={() => setActiveCompanyMenuId(null)}
                        />
                      )}
                  </div>
                  {/* {company.softdel && <span className="companyArchivedBadge">Archived</span>} */}
                </div>
              ))
            ) : (
              <div className="companyNoResults">
                <div className="companyNoResultsIcon">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.8333 22.1667C17.9887 22.1667 22.1667 17.9887 22.1667 12.8333C22.1667 7.67801 17.9887 3.5 12.8333 3.5C7.67801 3.5 3.5 7.67801 3.5 12.8333C3.5 17.9887 7.67801 22.1667 12.8333 22.1667Z"
                      stroke="#667085"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M24.5 24.5L19.5417 19.5417"
                      stroke="#667085"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <h2>No accounts found</h2>
                <p>
                  {Alert.companySearch
                    ? `No account matches "${Alert.companySearch}".`
                    : "Try changing the account type or archived filter."}
                </p>
              </div>
            )}
          </div>}
      </div>
    )
  );
}
